import { isEmpty } from "lodash";

/**
 * Keep payments settings on a loader until usable details arrive,
 * unless a real fetch failure was recorded.
 */
export function shouldShowPaymentsSettingsLoader({
  currentOfferLoading,
  loading,
  paymentDetails,
  paymentDetailsError
}) {
  if (currentOfferLoading || loading) {
    return true;
  }

  const hasUsablePaymentDetails =
    !isEmpty(paymentDetails) &&
    !isNaN(paymentDetails.end_date_in_seconds);

  if (!hasUsablePaymentDetails && !paymentDetailsError) {
    return true;
  }

  return false;
}

export function hasUsablePaymentDetails(paymentDetails) {
  return (
    !isEmpty(paymentDetails) && !isNaN(paymentDetails.end_date_in_seconds)
  );
}
